// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"ItemSlots_fadeIn__2AzO5","fadeOut":"ItemSlots_fadeOut__MnzcW"};